import { render } from "./empty-data.vue?vue&type=template&id=0e53a858&scoped=true&ts=true"
import script from "./empty-data.vue?vue&type=script&lang=ts"
export * from "./empty-data.vue?vue&type=script&lang=ts"

import "./empty-data.vue?vue&type=style&index=0&id=0e53a858&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e53a858"]])

export default __exports__